import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class CompanyLocationGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
      super(
        'Location List',
        ROUTE_PATH.internshipCompanyLocation,
        ROUTE_PATH.internshipComapny,
        true,
        true,
        8,
        false,
        true,
        ['locName'],
        true,
        [],
        {
          isDownloadExcel: true,
          excelFileName:
            'InternshipLocationList' + new Date().toLocaleDateString() + '.xlsx',
          btnLabel: 'Download List',
          headers: [
            { key: 'Location_Name', value: 'locName' },
            { key: 'Address', value: 'locAddress' },
            { key: 'Interns_Required', value: 'internRequired' },
          ],
        },
        false,
        { evalKey: 'openFormModal', evalParam: [1], decisiveParam: false },
        false,
        true,
        false,
        null,
        { evalKey: 'isDeletable', evalParam: ['0'], decisiveParam: false },
        false,
        null,
        {
          isPreview: false,
          isPreviewType: 'VIDEO',
          isEnvUrl: false,
          linkKey: ['filePath'],
          previewName: '',
        },
        {
          isTabSwitch: false,
          label: '',
          isChecked: false,
        },
        true,
        true,
        true,
        [],
        false,
        { isExtraActions: false, btnLabel: '' },
        {
          isCheckboxEmit: true,
          emitKey: 'id',
          checkedKey: '',
          valueKey: '',
        },
        { isDownload: false, key: '', valueKey: '' },
        { isTabStatus: false, label: '', isChecked: false },
        false,
        true,
        {
          isPrimary: false,
          isDanger: true,
        },
        '',
        {
          value:'',
          isVisible:true
        },
        true,
        true,
        false,
        {isExtraActions:false,btnLabel:''},
        {value:'Location',isVisible:true}
      );
    }

    override initProperties() {
      const dataInfo = super.initProperties();
         const isEdit:boolean=false;
      dataInfo.isEdit = isEdit
      return dataInfo
  }
  
    prepareHeaderList(): Headers[] {
      const headers: Headers[] = [];
      const location_name = new Headers(
        'Location Name',
        'locName',
        false,
        true,
        'text'
      );
      const address = new Headers('Address', 'locAddress', false, true, 'text');
      const interns = new Headers(
        'Intern required',
        'internRequired',
        false,
        true,
        'text'
      );
  
      headers.push(location_name);
      headers.push(address);
      headers.push(interns);
  
      return headers;
    }
  }
  